import MuiDialog from '@mui/material/Dialog';
import { index, Options } from 'shared/assets/styles/z-index';
import styled, { css } from 'styled-components';

// MUI's dialog level sits below PopupMenu; `&&` beats the variant's own zIndex in the theme overrides
export const Dialog = styled(MuiDialog)<{ $abovePopups?: boolean }>`
  ${({ $abovePopups }) =>
    $abovePopups &&
    css`
      && {
        z-index: ${index(Options.POPUP_DIALOG)};
      }
    `};
`;

export const Header = styled.div`
  padding: ${({ theme }) =>
    `${theme.spacing(5)} ${theme.spacing(6)} ${theme.spacing(2)} ${theme.spacing(6)}`};
`;

export const Interactions = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(2)};
  justify-content: flex-end;

  padding: ${({ theme }) => `${theme.spacing(4)} ${theme.spacing(4)}`};
`;
